<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Editar Tabela de Preço",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader },
  setup() {

  },
  data() {
    return {
      submittedProdPreco: false,
      prodPrecoSelecionado: null,
      showModalProdPreco: false,
      loadingList: false,
      pesqTextFilter: null,
      prodPrecosData: {},
      errosValid: null,
      tabPrecoData: {
        id: 0,
        status: 'A'
      },
      idData: 0,
      updating: true,
      activeTab: 0,
      submitted: false,

      title: "Editar Tabela de Preço",
      items: [
        {
          text: "Tabelas de Preços",
          href: "/tabprecos/list",
        },
        {
          text: "Editar Tabela de Preço",
          active: true,
        },
      ],

    };
  },

  methods: {

    selecionaProdPreco(prodPrecoData){
      this.prodPrecoSelecionado = prodPrecoData
      this.showModalProdPreco = true
    },


    formSubmitProdPreco() {
      console.log('formSubmitProdPreco')
      this.submittedProdPreco = true

      if (this.prodPrecoSelecionado.preco > 0){
        this.showModalProdPreco = false
        api.post(`${getBaseUrl()}api/prodpreco`, {
          prodPrecoData: this.prodPrecoSelecionado
        }).then((res) => {
          console.log('then axios')
          console.log(res)

          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })


        })
      }
    },

    atualizaDataList() {
      console.log('atualizaDataList')

      this.loadingList = true
      api.get(`${getBaseUrl()}api/tabprpesqprod`, {
        params: {
          'q': this.pesqTextFilter,
          'tab': this.tabPrecoData.codigo
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.prodPrecosData = res.data
        this.loadingList = false
      })
    },


    carregarDados(){
      api.get(`${getBaseUrl()}api/tabpreco`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.tabPrecoData = res.data[0]
        this.prodPrecosData = res.data[1]

        this.idData = this.tabPrecoData.id
        this.title = `Editar Tabela de Preço (${this.tabPrecoData.id}) ${this.tabPrecoData.descricao}`
        this.updating = false
      });
    },


    formSubmit(){
      console.log('formSubmit')
      this.submitted = true;

      this.updating = true
      this.errosValid = []
      api.post(`${getBaseUrl()}api/tabpreco`, {
        tabPrecoData: this.tabPrecoData
      }).then((res) => {
        console.log('then axios')
        console.log(res)

        this.updating = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        if (this.idData === 0){
          this.idData = res.data[0].id
          this.$router.replace('/tabpreco/editar/' + this.idData)
        }

      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
        this.activeTab = 0
      })
    },



    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

  },


  mounted() {
    console.log('mounted_tabprecos_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData > 0){

      this.carregarDados()

    }else{

      this.title = `Criando Nova Tabela de Preço`
      this.updating = false
    }


  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="checkout-tabs" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <b-button variant="outline-primary" class="mx-2" @click="formSubmit"  >
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>


<!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" :disabled="true">-->
<!--                <i class="bx bx-printer font-size-16 align-middle me-2"></i>-->
<!--                Integrar Corpem-->
<!--              </b-button>-->

              <b-button variant="outline-danger" class="mx-2" :disabled="true" >
                <i class="bx bx-purchase-tag-alt font-size-16 align-middle me-2"></i>
                Novo Preço
              </b-button>

              <b-button variant="outline-warning" class="mx-2" :disabled="true">
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Reajuste de Tabela
              </b-button>

            </div>
          </div>
        </div>
      </div>


      <b-tabs
          v-model="activeTab"
          pills
          vertical
          nav-class="p-0"
          nav-wrapper-class="col-xl-2 col-sm-3"
          content-class="w-100">
        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-briefcase d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Principal</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Informações Principais</h4>
<!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

                <form class="needs-validation" @submit.prevent="formSubmit">


                    <div class=" row mb-3">
                      <div class="col-md-8">
                        <div class="mb-3">
                          <label for="descricao">Descrição</label>
                          <input
                              id="descricao"
                              v-model="tabPrecoData.descricao"
                              type="text"
                              class="form-control"
                              placeholder="Descrição"
                              :class="{'is-invalid': submitted && !tabPrecoData.descricao}"/>
                          <div v-if="submitted && !tabPrecoData.descricao"
                               class="invalid-feedback">
                            <span>Campo descrição obrigatório, favor preencher.</span>
                          </div>
                        </div>
                      </div>



                      <div class="col-md-2">
                        <label for="codigo">Código</label>
                        <div class="position-relative">
                          <input
                              id="codigo"
                              type="text"
                              v-model="tabPrecoData.codigo"
                              class="form-control"
                              placeholder="Código"
                              :disabled="tabPrecoData.id"
                              :class="{'is-invalid': submitted && !tabPrecoData.codigo}"/>
                          <div v-if="submitted && !tabPrecoData.codigo" class="invalid-feedback">
                            <span>Campo código obrigatório, favor preencher.</span>
                          </div>
                        </div>
                      </div>


                      <div class="col-md-2 mt-2">
                        <div class="mb-3 align-items-end align-content-end float-end">
                          <span for="tel1">Status</span>
                          <div class="position-relative">
                            <b-form-checkbox
                                switch size="lg"
                                value="A"
                                unchecked-value="I"
                                v-model="tabPrecoData.status">
                              {{ tabPrecoData.status === 'A' ? 'Ativo' : 'Inativo' }}
                            </b-form-checkbox>
                          </div>
                        </div>
                      </div>

                    </div>




                    <div class=" row mb-3">

                      <div class="col-md-2">
                        <label for="codfor">Código Fornecedor</label>
                        <div class="position-relative">
                          <input
                              id="codfor"
                              type="text"
                              :disabled="true"
                              class="form-control"
                              placeholder="Código Fornecedor"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="codred">Código Reduzido</label>
                        <div class="position-relative">
                          <input
                              id="codred"
                              type="text"
                              :disabled="true"
                              class="form-control"
                              placeholder="Código Reduzido"/>
                        </div>
                      </div>




                    </div>


                  <hr />

                  <div class="row mb-3">

                    <div class="col-md-2">
                      <label for="pesobrt">Início Vigência</label>
                      <div class="position-relative">
                        <input
                            id="pesobrt"
                            type="number"
                            :disabled="true"
                            class="form-control text-end"
                            placeholder="Início Vigência"/>
                      </div>
                    </div>


                    <div class="col-md-2">
                      <label for="pesoliq">Final Vigência</label>
                      <div class="position-relative">
                        <input
                            id="pesoliq"
                            type="number"
                            :disabled="true"
                            class="form-control text-end"
                            placeholder="Final Vigência"/>
                      </div>
                    </div>


                  </div>

                  <div class="row">

                    <div class="col-md-2">
                      <label for="compr">Condição</label>
                      <div class="position-relative">
                        <input
                            id="compr"
                            type="number"
                            :disabled="true"
                            class="form-control text-end"
                            placeholder="Condição"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="larg">Tipo Operação</label>
                      <div class="position-relative">
                        <input
                            id="larg"
                            type="number"
                            :disabled="true"
                            class="form-control text-end"
                            placeholder="Tipo Operação"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="altu">Cliente</label>
                      <div class="position-relative">
                        <input
                            id="altu"
                            type="number"
                            :disabled="true"
                            class="form-control text-end"
                            placeholder="Cliente"/>
                      </div>
                    </div>

                  </div>


                </form>


              </div>
            </div>

          </b-card-text>


        </b-tab>



        <b-tab>
          <template v-slot:title>
            <i class="bx bx-money d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Produtos</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">

                    <div class="row mb-2">

                      <div class="col-sm-2">
                        <div class="search-box me-2 mb-2 d-inline-block">
                          <div class="position-relative">
                            <input
                                id="inputPesquisa"
                                type="text"
                                v-model="pesqTextFilter"
                                class="form-control"
                                placeholder="Enter para pesquisar..."
                                @change="atualizaDataList"/>
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>

                    </div>


<!--                    <h4 class="card-title mb-4">Produtos na Tabela de Preço</h4>-->
<!--                    <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

                    <div class="table-responsive" v-if="prodPrecosData && prodPrecosData.length > 0">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Nome</th>
                          <th scope="col">Data</th>
                          <th scope="col" class="text-end">Valor</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data in prodPrecosData" :key="data.id" @click="selecionaProdPreco(data)">

                          <td>
                            <a href="javascript: void(0);" class="text-body fw-bold">
                              #{{ data.id }}
                            </a>
                          </td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <a href="javascript:void(0);" class="text-dark">
                                {{ data.descricao }}
                              </a>
                            </h5>
                            <p class="text-muted mb-0">{{ data.produto }}</p>
                          </td>
                          <td>{{ formatDateTime(data.created_at) }}</td>
                          <td class="text-end">R$ {{ formatDecimal(data.preco) }}</td>

                          <td>
                            <div class="button-items text-end">

                              <b-button variant="outline-warning" @click="selecionaProdPreco(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>

<!--                              <b-button variant="outline-danger" @click="deletar(data.id)" :disabled="data.email === 'admin@admin.com.br'">-->
<!--                                <i class="mdi mdi-trash-can d-block font-size-16"></i>-->
<!--                              </b-button>-->

                            </div>
                          </td>

                        </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-6">
                <button
                    @click="activeTab = 2"
                    class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left me-1"></i> Voltar para Automações
                </button>
              </div>



            </div>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>


    <b-modal v-if="prodPrecoSelecionado && prodPrecoSelecionado.id"
             :title="prodPrecoSelecionado.id != null ? `Editar Preço de Produto (${ prodPrecoSelecionado.id })` : 'Criar Novo Preço'"
             v-model="showModalProdPreco" hide-footer>
      <form @submit.prevent="formSubmit">
        <div class="row">

          <div class="col-12">
            <div class="mb-3">
              <label for="descricao">Produto</label>
              <input
                  id="descricao"
                  v-model="prodPrecoSelecionado.descricao"
                  type="text"
                  class="form-control"
                  placeholder="Inserir descrição"
                  disabled="true"
                  :class="{'is-invalid': submitted && v$.prodPrecoSelecionado.descricao.$error,}"/>
              <div
                  v-if="submitted && v$.prodPrecoSelecionado.descricao.$error"
                  class="invalid-feedback">
                <span v-if="v$.prodPrecoSelecionado.descricao.required.$message">
                  {{ v$.prodPrecoSelecionado.descricao.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="produto">Código</label>
              <input
                  id="produto"
                  v-model="prodPrecoSelecionado.produto"
                  type="text"
                  class="form-control"
                  placeholder="Inserir código"
                  disabled="true"
                  :class="{'is-invalid': submitted && v$.prodPrecoSelecionado.produto.$error,}"/>
              <div
                  v-if="submitted && v$.prodPrecoSelecionado.produto.$error"
                  class="invalid-feedback">
                <span v-if="v$.prodPrecoSelecionado.produto.required.$message">
                  {{ v$.prodPrecoSelecionado.produto.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="selectStatus">Status</label>
              <b-form-select
                  id="selectStatus"
                  v-model="prodPrecoSelecionado.status"
                  class="mb-3 form-select form-control"
                  :class="{'is-invalid': submitted && v$.prodPrecoSelecionado.status.$error,}">
                <b-form-select-option value="A">
                  Ativo
                </b-form-select-option>
                <b-form-select-option value="I">
                  Inativo
                </b-form-select-option>
                <b-form-select-option value="L">
                  Análise
                </b-form-select-option>
              </b-form-select>
              <div v-if="submitted && v$.prodPrecoSelecionado.status.$error" class="invalid-feedback">
                <span v-if="v$.prodPrecoSelecionado.status.required.$message">
                  {{ v$.prodPrecoSelecionado.status.required.$message }}
                </span>
              </div>

            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="desconto">Desconto Máximo</label>
              <input
                  id="desconto"
                  v-model="prodPrecoSelecionado.desconto"
                  type="number"
                  disabled="true"
                  class="form-control"
                  placeholder="Desconto Máximo"/>
            </div>
          </div>


          <div class="col-6">
            <div class="mb-3">
              <label for="preco">Preço</label>
              <input
                  id="preco"
                  v-model="prodPrecoSelecionado.preco"
                  type="number"
                  class="form-control text-end"
                  placeholder="Inserir descrição"
                  :class="{'is-invalid': submittedProdPreco && !prodPrecoSelecionado.preco,}"/>
              <div
                  v-if="submittedProdPreco && !prodPrecoSelecionado.preco"
                  class="invalid-feedback">
                <span v-if="submittedProdPreco && !prodPrecoSelecionado.preco">
                  Campo preço obrigatório, favor preencher.
                </span>
              </div>
            </div>
          </div>

        </div>

        <div class="text-end mt-3">
          <b-button variant="light" @click="showModal = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
          <b-button variant="success" class="ms-1" @click="formSubmitProdPreco">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>

      </form>

    </b-modal>






    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>




  </Layout>
</template>
